<template>
  <div :class="classProp">
    <div>
      {{ this.$lang.messages.demoDisclaimerTitle }}
    </div>
    <div>
      <span>{{ this.$lang.messages.demoDisclaimerText }}</span>
      <a href="https://app.familipay.com/email/" target="_blank">3 month free trial</a>
    </div>
  </div>
</template>

<script>
  export default {
    name: "DemoDisclaimer",
    props: {
      classProp: {
        type: String,
        required: false,
        default: ''
      }
    },
  }
</script>